import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=f863e5b2"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports